export default __webpack_public_path__ + "static/media/node-js-logo.22b2d373.svg";